import React from 'react'
import ContentLoader from 'react-content-loader'
import { useIsDarkMode } from '../../../../state/user/hooks'
import INFTImageSkeleton from './INFTImageSkeleton'

export default function NFTImageSkeleton({ width, height, viewBox, speed }: INFTImageSkeleton) {
  const darkMode = useIsDarkMode()
  return (
    <ContentLoader
      speed={speed ? speed : 2}
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      viewBox={viewBox ? viewBox : '0 0 224 224'}
      backgroundColor={darkMode ? `#6C7284` : `#5f626d`}
      foregroundColor={darkMode ? `#848994` : `#d7d7d7`}
    >
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
    </ContentLoader>
  )
}
